import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { get } from '../api/client';
import { useAuth } from '../context/AuthContext';

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshAuth } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    async function processCallback() {
      const code = searchParams.get('code');
      if (!code) {
        navigate('/login', { replace: true });
        return;
      }

      try {
        // Send authorization code to backend to complete OIDC exchange & set cookie
        await get(`/api/auth/callback?code=${encodeURIComponent(code)}`);
        await refreshAuth();
        navigate('/', { replace: true });
      } catch (err) {
        console.error('Keycloak callback error:', err);
        setError(err?.message || 'Authentication failed during Keycloak token exchange.');
      }
    }

    processCallback();
  }, [searchParams, navigate, refreshAuth]);

  if (error) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0B0F19',
        color: '#F8FAFC',
        fontFamily: 'sans-serif',
        padding: '24px'
      }}>
        <div style={{
          maxWidth: '400px',
          background: 'rgba(30, 41, 59, 0.8)',
          border: '1px solid rgba(239, 68, 68, 0.3)',
          borderRadius: '12px',
          padding: '24px',
          textAlign: 'center'
        }}>
          <h2 style={{ color: '#F87171', margin: '0 0 12px', fontSize: '18px' }}>Authentication Error</h2>
          <p style={{ color: '#94A3B8', fontSize: '14px', marginBottom: '20px' }}>{error}</p>
          <button
            onClick={() => navigate('/login', { replace: true })}
            style={{
              background: '#2563EB',
              color: '#FFF',
              border: 'none',
              padding: '10px 18px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 600
            }}
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: '#0B0F19',
      color: '#94A3B8',
      fontFamily: 'sans-serif'
    }}>
      <div style={{
        width: '36px',
        height: '36px',
        border: '3px solid rgba(255, 255, 255, 0.1)',
        borderTopColor: '#3B82F6',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }} />
      <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      <p style={{ marginTop: '16px', fontSize: '14px' }}>Completing Keycloak sign in...</p>
    </div>
  );
}
